module.exports = __webpack_public_path__ + "img/03.5fd605a8.png";